exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".entity-label{font-size:20px;color:#0c64eb;margin-right:10px}.entity-select{width:400px}.entity-select .el-input__inner{height:50px}.entity-select-dropdown .el-select-dropdown__item,.entity-select .el-input{font-size:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4339d0f4","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/compo/user/ScopeEntityList.vue
// module id = 4616
// module chunks = 0